import React from 'react'
import CardUI from '../../../../widgets/layout/CardUI'
import BadgeUI from '../../../../widgets/output/BadgeUI'
import FileUploadModalSF from '../../../../widgets/form/FileUploadModalSF'
import ButtonTinyUI from '../../../../widgets/action/ButtonTinyUI'
import LinkWithSpinnerUI from '../../../../widgets/action/LinkWithSpinnerUI'
import ButtonTinyWithSpinnerUI from '../../../../widgets/action/ButtonTinyWithSpinnerUI'

const AddendumSignUI = ({ context, loan, selectedAddendumId,
  addendumUploadMode, onAddendumUpload, onAddendumUploadClick, onCancelAddendumUpload,
  onAddendumDownloadClick, downloadRequested,
  onAddendumSubmit, addendumSubmitted, addendumSuccessMsg, addendumErrorList }) =>
  <div>
    {
      loan.addendumSignList.map((addendum, i) =>
        <div key={i}>
          <CardUI title={addendum.addendumId !== 'null' ? `Addendum ${i + 1}` : 'null'} className='g_m_top_100'>
            <div className='g_flex_h g_flex_top' >
              <span>
                {
                  addendum.directorSignList && addendum.directorSignList.map((dir, j) =>
                    <div key={j}>
                      {dir.fullName}, borrower
                      {
                        dir.signDateF1 &&
                        <span className='g_muted'>, signed {dir.signDateF1}</span>
                      }
                    </div>
                  )
                }
                {
                  addendum.lenderSignee &&
                  <div>{addendum.lenderSignee}, lender
                    {
                      addendum.lenderSignDateF1 &&
                      <span className='g_muted'>, signed {addendum.lenderSignDateF1}</span>
                    }
                  </div>
                }
                {
                  addendum.escrowSignee &&
                  <div>{addendum.escrowSignee}, escrow
                    {
                      addendum.escrowSignDateF1 &&
                      <span className='g_muted'>, signed {addendum.escrowSignDateF1}</span>
                    }
                  </div>
                }
              </span>
              <BadgeUI label={addendum.status} />
            </div>

            <div className='g_m_top_100'>
              <b>Standard Addendum</b>
              <ButtonTinyWithSpinnerUI label='Send to Leegality for eSigning'
                rowId={addendum.addendumId} className='g_m_top_25'
                onClick={onAddendumSubmit}
                alignLeft={true} busy={selectedAddendumId === addendum.addendumId && addendumSubmitted}
                successMsg={addendumSuccessMsg} errorList={addendumErrorList}
              />
            </div>

            <div className='g_m_top_100'>
              <b>Custom Addendum</b>
              <span className='g_flex_h g_m_top_25'>
                <ButtonTinyUI label='Send to Leegality for eSigning with PDF Upload'
                  rowId={addendum.addendumId} onClick={onAddendumUploadClick} />
              </span>
            </div>


            <div className='g_m_top_100'>
              <b>Published Addendum</b>
              <LinkWithSpinnerUI label='Download addendum'
                onClick={onAddendumDownloadClick}
                rowId={addendum.addendumId}
                busy={selectedAddendumId === addendum.addendumId && downloadRequested}
                spinnerOnLeft={false}
              />
            </div>
          </CardUI>

          <FileUploadModalSF
            context={context}
            uploadMode={addendumUploadMode}
            onUpload={onAddendumUpload}
            onCancelClick={onCancelAddendumUpload}
            signedUrlApi={`/api/su/loans/${loan.loanId}/addendum/${selectedAddendumId}/pdfDocuments/fileUploadSignedUrl`}
          />
        </div>
      )
    }
  </div>

export default AddendumSignUI
